<div>
  <mat-form-field [appearance]="options?.appearance ? options.appearance : 'standard'">
    <mat-label>{{options?.title}}<span class="asterisk"
        *ngIf="utils.isRequiredField(inputFormControl)">*</span></mat-label>
    <input type="text" #inputAutocomplete (keyup)="changeInput()" matInput autocomplete="off" matGoogleMapsAutocomplete
      [formControl]="formControlAddress">
    <mat-error *ngIf="formControlAddress?.errors?.required">
      {{ utils.giveMessageError('MANDATORY_FIELD') }}
    </mat-error>
    <mat-hint *ngIf="formControlAddress?.value && (!inputFormControl?.value?.location?.lat || !inputFormControl?.value?.location?.lng) 
    && options?.showHintRequiredAddressSelection" class="danger-text">
      {{ formControlAddress.enabled
      ? "Debes seleccionar una opción de la lista."
      : "Esta dirección no está georeferenciada." }}
    </mat-hint>
    <i *ngIf="!showCorrectAddress && options?.correctAddress && inputFormControl?.value?.location?.lat && inputFormControl?.value?.location?.lng 
      && inputFormControl?.value?.address && formControlAddress.enabled" matSuffix matTooltip="Corregir dirección"
      class="fas fa-edit cursor-pointer color-primary" (click)="openAddressCorrection()"></i>
    <i matSuffix matTooltip="Seleccionar ubicación desde el mapa" matTooltipPosition="right"
      class="fas fa-map-marked-alt autocomplete__tooltip-icon cursor-pointer mr-2" (click)="selectAddressOnMap()"
      *ngIf="options?.selectAddressOnMap && formControlAddress.enabled"></i>
    <i *ngIf="inputFormControl?.value?.location?.lat && inputFormControl?.value?.location?.lng &&
     inputFormControl?.value?.address && formControlAddress.enabled && options?.cleanAddress" matSuffix
      matTooltip="Borrar dirección" matTooltipPosition="right" class="fas fa-times" (click)="deleteAddress()"></i>
  </mat-form-field>

  <div *ngIf="showCorrectAddress" class="alias-form">
    <mat-form-field appearance="standard">
      <mat-label>Dirección corregida</mat-label>
      <input type="text" autocomplete="off" matInput [formControl]="newAddressSelected">
      <i matSuffix matTooltip="Guardar" class="fas fa-check cursor-pointer" (click)="addressCorrection(true)"></i>
      <i matSuffix matTooltip="Cancelar" class="fas fa-times cursor-pointer" (click)="addressCorrection(false)"></i>
    </mat-form-field>
  </div>
</div>